import { render, staticRenderFns } from "./Details.vue?vue&type=template&id=55ca2eb4"
import script from "./Details.vue?vue&type=script&lang=js"
export * from "./Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55ca2eb4')) {
      api.createRecord('55ca2eb4', component.options)
    } else {
      api.reload('55ca2eb4', component.options)
    }
    module.hot.accept("./Details.vue?vue&type=template&id=55ca2eb4", function () {
      api.rerender('55ca2eb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/activity_item/Details.vue"
export default component.exports